import {useState} from 'react';
import {useFormik} from 'formik';
import {useLocale, useTranslations} from 'next-intl';
import getErrorsFromResponse from '../../services/getErrorsFromResponse';
import FormTextInput from 'src/components/FormTextInput';
import BaseButton from 'src/components/BaseButton';
import {clientRequest} from 'src/client/apiClient';
import {useLogin} from 'src/utils/auth/authUtils';

const initialValues = {
  email: '',
  password: ''
};

type Props = {
  onSignInSuccess?: (user: User) => void;
  brandStyle: BrandStyle;
};

const LoginForm = ({onSignInSuccess, brandStyle}: Props) => {
  const t = useTranslations();
  const locale = useLocale();

  const [isLoading, setLoading] = useState(false);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const {onLogin} = useLogin();

  const onSubmit = (values: any) => {
    setLoading(true);

    return clientRequest<any>({
      url: '/users/login',
      options: {method: 'POST'},
      body: {...values, language: locale}
    })
      .then(({user, token}) => {
        onLogin(token, user);

        if (user && onSignInSuccess) {
          setTimeout(() => onSignInSuccess(user));
        }
      })
      .catch(async (response) => {
        const errors = await getErrorsFromResponse(response);
        setLoading(false);

        setErrorMessages(errors);
      });
  };

  const formik = useFormik({initialValues, onSubmit});

  return (
    <div className="big-card w-full p-5">
      <form id="login-form" onSubmit={formik.handleSubmit}>
        <FormTextInput
          className="highlight-block"
          id="email"
          brandStyle={brandStyle}
          label={t('common.email')}
          type="email"
          formikProps={formik}
        />

        <FormTextInput
          className="highlight-block"
          id="password"
          brandStyle={brandStyle}
          label={t('common.password')}
          type="password"
          formikProps={formik}
        />

        <BaseButton
          size="large"
          isLoading={isLoading}
          type="submit"
          variant="primary"
          className="w-full"
          style={{backgroundColor: brandStyle.primaryColor}}
          label={t('common.sign in')}
          onClick={formik.submitForm}
        />
      </form>

      {errorMessages.map((errorMessage, index) => (
        <p className="w-full text-sm mt-3 text-[--error-color]" key={index}>
          {errorMessage}
        </p>
      ))}
    </div>
  );
};

export default LoginForm;
